import { Component } from '@angular/core';

@Component({
  selector: 'app-device-layout',
  templateUrl: './device-layout.component.html',
  styleUrls: ['./device-layout.component.scss']
})
export class DeviceLayoutComponent {
  // imgSrc: string = '../../../../assets/images/auth_images/auth_image.svg';
  logoImg: string = 'assets/images/auth_images/safeignite_logo.svg'
}
